/* unplugin-vue-components disabled */import script from "./GaiTop.vue?vue&type=script&setup=true&name=GaiTop&lang=js"
export * from "./GaiTop.vue?vue&type=script&setup=true&name=GaiTop&lang=js"

import "./GaiTop.vue?vue&type=style&index=0&id=7f04343a&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f04343a"]])

export default __exports__